export const Border = {
  color: {
    default: '#dadfe2',
  },
  radius: {
    default: '3px',
    large: '10px',
  },
  size: {
    default: '1px',
  },
  get default() {
    return `${this.size.default} solid ${this.color.default}`;
  },
};
